<template>
    <div @keyup.enter="login" :style="styletop" v-show="islogin">
        <!-- <img class="img" src="../../assets/APP/bak2.png"/> -->
            <div v-show = "isPassWord">
                <p class="pcStyle" @click="onAuthCode" >手机登录</p>
                <div v-show ="isLogo" :style="topStyle">
                    <img style="position: relative; width:55%;"  :src="logoImg"/>
                </div>
                
                <div v-show ="isLogo1" style="height:15%">
                    <img style="height: 100%;"  :src="logoImg"/>
                </div>
                <div style="height:15%">
                    <div>
                        <Input 
                        v-model="account" 
                        :autofocus="autofocus" 
                        prefix="ios-contact" 
                        placeholder="账号" 
                        style="width: 60%" />
                    </div>
                    <div class="topHeight">
                        <Input 
                        v-model="passWord" 
                        :autofocus="autofocus" 
                        type="password"
                        prefix="ios-lock" 
                        placeholder="密码" 
                        style="width: 60%" />
                    </div>
                    <div class="topHeight">
                    </div>
                    <div class="topHeight">
                        <Button 
                            type="success"
                            @click="login"
                            style="width: 60%"
                        >登录</Button>
                    </div>
                    <div class="topHeight">
                    <!--  <Button type="warning" @click="registerUser" style="width: 60%">注册/修改</Button> -->
                    </div>
                    <div class="downloadApp">
                        <a :href="downloadUrl" download="FWebViewApp.apk">下载app客户端</a>
                        <!-- <a @click="downLoad">下载app客户端</a> -->
                    </div>
                    
                </div>
            </div>
            <div v-show = "isAuthCode">
                <p class="backStyle"  ><Icon type="ios-arrow-back" @click="onPassWord"/></p>
                <div v-show ="isLogo" :style="topStyle">
                    <img style="position: relative; width:55%;"  :src="logoImg"/>
                </div>
                
                <div v-show ="isLogo1" style="height:15%">
                    <img style="height: 100%;"  :src="logoImg"/>
                </div>
                <div style="height:15%">
                    <div>
                        <Input 
                        v-model="phoneCode" 
                        :autofocus="autofocus"  
                        prefix="ios-phone-portrait" 
                        placeholder="手机号" 
                        style="width: 60%" />
                    </div>
                    <div class="topHeight">
                        <Input 
                        v-model="authCode" 
                        :autofocus="autofocus" 
                        prefix="ios-lock" 
                        placeholder="验证码" 
                        :disabled="isAuthSet"
                        style="width: 33%" />
                        <Button style="width: 25%" @click="getCode" :disabled="isGetSet">{{count}}</Button>
                    </div>
                    
                    <div class="topHeight">
                    </div>
                    <div class="topHeight">
                        <Button 
                            type="success"
                            @click="login"
                            style="width: 60%"
                        >登录</Button>
                    </div>
                    <div class="topHeight">
                    <!--  <Button type="warning" @click="registerUser" style="width: 60%">注册/修改</Button> -->
                    </div>
                    <div class="downloadApp">
                        <a :href="downloadUrl" download="FWebViewApp.apk">下载app客户端</a>
                        <!-- <a @click="downLoad">下载app客户端</a> -->
                    </div>
                    
                </div>
            </div>
    </div>
</template>
<style>
    .pcStyle{
        text-align: right;
        font-size: 18px;
        padding-right: 15px;
        height: 30px;
        line-height: 30px;
        background: #cccccc4a;
    }
    .backStyle{
        text-align: left;
        font-size: 25px;
        height: 30px;
        line-height: 30px;
        color: #0e1e8e;
        background: #cccccc4a;
    }
    .topHeight{
        padding-top: 7%;
    }
    .img {
        position: relative;
        width:52%;
    }
    .ivu-customtabs.ivu-tabs {
        color: #ffffff;
    }

    .ivu-customtabs .ivu-tabs-nav .ivu-tabs-tab-active {
        color: #09ebecfa;
    }
    .downloadApp{
        padding-top: 10%;
    }
    .downloadApp a {
        color: #FF5722;
        font-size: 16px;
    }
</style>
<script>
import md5 from 'js-md5';
import axios from 'axios';
axios.defaults.withCredentials = true;
export default {
    name : "login",
    mounted : function(){
        this.$store.registerModule(['system','loginApp'],{
            state : {
                $ : this
            }
        });
        window.onresize =()  =>{
            return (()=>{
                
            })()
        }
        this.styletop = {
                width : innerWidth +"px",
                height: innerHeight +"px",
                color: "#fff",
                margin:"0px",
                padding:"0px",
                overflowX:"hidden",
                overflowY:"hidden",
                background : 'url(../../static/appBc.png)',
                backgroundSize : 'cover'
            }
        this.topStyle = {
            paddingTop:" 10%",
            // paddingBottom: "15%"
            height: "35%",
        }
        this.hengshuping();
    },
    data : function(){
        return {
            downloadUrl: debugFWebView + "client/download/FWebViewApp.apk",
            topStyle:{},
            logoImg:'../../static/logo.png' ,//图片
            isLogo:true,
            isLogo1:false,
            islogin : false,
            account : "",
            passWord : "",
            single : false,
            styletop : {
                
            },
            onSuccess : null,
            autofocus : true,
            defaultLogin : "SmartWorx",
            socketId : "",
            authCode:"",//验证码
            phoneCode:"",//手机号
            isAuthCode:false,//验证码显示
            isPassWord:true,//用户登录,
            isAuthSet:true,//是否可以输入
            isGetSet:false,//是否可以点击
            count: '获取验证码',
            timer: null,
        }
    },
    methods : {
        //验证手机号
        checkPhone : function(phone){
            if(!(/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(phone))){ 
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?'手机号码有误！' : 'Wrong mobile phone number!');
                return true; 
            }else{
                return false;
            }
        },
        //验证码倒计时
        getCode : function(){
            if(this.checkPhone(this.phoneCode)) return;//验证号码
            this.isAuthSet = false;//启用输入
            this.isGetSet = true;//禁用按钮
            var TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    } else {
                    this.isGetSet = false;//启用按钮
                    this.count = "获取验证码";
                    clearInterval(this.timer);
                    this.timer = null;
                    }
                }, 1000)
            }
            //调用接口发送短信
            var url = window.debugFWebView+"requestAuthCode";
            axios.post(url,{
                    userName: this.phoneCode //手机号
                }).then(function(result){
                if(result.err){
                    this.$Message.error(result.err);
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        },
        onAuthCode : function(){
            this.isAuthCode = true;
            this.isPassWord = false;
        },
        onPassWord : function(){
            this.isAuthCode = false;
            this.isPassWord = true;
        },
        show : function(isShow,socketId){
            this.islogin = isShow ? true : false;
            if(this.islogin){
                this.socketId = socketId;
                this.$store.state.system.alarmCenter.$.show(false);
                this.$store.state.system.webmaster.$.show(false);
                this.$store.state.system.manager.$.closeAllView();
            }
        },
        waiting : function(){
            return new Promise((resolve)=>{
                this.onSuccess = resolve;
            });
        },
        hengshuping(){
            if(window.orientation==180||window.orientation==0){
                this.isLogo = true;
                this.isLogo1 = false;
            }
            if(window.orientation==90||window.orientation==-90){
                    this.isLogo = false;
                    this.isLogo1 = true;
            }
        },
        login : function(){
            if(this.isPassWord){
                if(this.account == ""){
                    this.$Message.error(this.$store.state.system.$.languageName == "ch" ?'请输入账号！' : 'Please enter your account number!');
                    return;
                }else if(this.passWord == ""){
                    this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入密码！":"Please enter your password!");
                    return;
                }
            }else{
                //判断验证码
                if(this.phoneCode == ""){
                     this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入手机号":"Please input mobile phone number!");
                     return;
                }
                //判断验证码
                if(this.authCode == ""){
                     this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"请输入验证码":"Please enter the verification code!");
                     return;
                }
            }
            var url = window.debugFWebView;
            switch(this.defaultLogin){
                case "SmartWorx":
                    url += "/login";
                break;
                case "webmaster":
                    url += "/webmaster";
                break;
                case "alarm":
                    url += "/alarm";
                break;
                default:
                    url += "/login";
                break;
            }
            if(this.isPassWord){
                var data = {
                    userName: this.account,
                    passWord: md5(this.passWord),
                    socketId : this.socketId
                }
            }else{
                var data = {
                    userName: this.phoneCode,
                    authCode: this.authCode,
                    socketId : this.socketId
                }
            }
            axios.post(url,data).then(function(result){
                if(result.data.err){
                    this.$Message.error(result.data.err);
                }else{
                    this.onSuccess({
                        userName : result.data.userName,
                        key : result.data.key,
                        type : this.defaultLogin,
                        data : result.data
                    });
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
            
        },
        downLoad:function(){
         let link = document.createElement('a')
            axios({
                url: window.debugFWebView + "App/download",
                method: 'post',
                onDownloadProgress: p => {
                    this.precent = Math.floor(100 * (p.loaded / p.total))
                },
                responseType: 'blob'
            }).then(data => {
                // 如果后端用encodeURI对文件名进行了编码，前端需用decodeURI进行解码（主要为处理特殊字符）
                let fileName = 'FWebViewApp.apk';
                // 由于ie不支持download属性，故需要做兼容判断
                if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                    // ie独有的msSaveBlob属性，data.data为Blob文件流
                    window.navigator.msSaveBlob(data.data, fileName)
                } else {
                    // 以下流程即为文章开始的下载流程
                    let url = window.URL.createObjectURL(data.data)
                   
                    link.style.display = 'none'
                    link.href = url
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                    window.URL.revokeObjectURL(link.href);
                }
            })
        },
        registerUser:function(){
            this.islogin = false;
            this.$store.state.system.$.isShowProgress = false;
            this.$store.state.system.userRegister.$.show(true);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/loginApp.vue